export function StaticImplements<T>() {
  return (_constructor: T) => {
    /* EMPTY */
  }
}
